import { Button, Col, Modal, Popconfirm, Row, message } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LoadingOutlined } from '@ant-design/icons';

import { AppDispatch, RootState } from '../../store/store';
import { cancelApplicationThunk } from '../../services/applicationService/applicationThunk';
import { cancelSmeApplicationThunk } from '../../services/smeApplicationService/smeApplicationThunk';

const ConfirmCancelApplication = ({
  callback,
  agreementType,
}: {
  callback: any;
  agreementType?: string;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { agreementDetails } = useSelector((state: RootState) => state.agreement);

  const { agreementDetails: smeAgreementDetails } = useSelector(
    (state: RootState) => state.smeAgreement
  );

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onCancelApplication = () => {
    setLoading(true);

    if (agreementType === 'SME') {
      dispatch(
        cancelSmeApplicationThunk({
          id: smeAgreementDetails?.data?.smeApplicationId,
        })
      )
        .unwrap()
        .then(async (res) => {
          message.success('SME Application cancelled successfully');
          callback();
        })
        .finally(() => {
          setIsModalOpen(false);
          setLoading(false);
        });
    } else {
      dispatch(
        cancelApplicationThunk({
          applicationId: agreementDetails?.data?.application?.id,
        })
      )
        .unwrap()
        .then(async (res) => {
          message.success('Application cancelled successfully');
          callback();
        })
        .finally(() => {
          setIsModalOpen(false);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Popconfirm
        title="Cancel this application?"
        description="Are you sure to cancel this application?"
        onConfirm={onCancelApplication}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
      >
        <Button disabled={loading} danger className="float-right">
          Cancel
        </Button>
      </Popconfirm>
    </>
  );
};

export default ConfirmCancelApplication;
